<template>
  <div class="full-page-width relative locations">
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name" v-if="get_end_of_day !== null">{{ `EOD #${get_end_of_day.batch_number}` }}</p>
      </div>
      <Dropdown
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
      <a
        style="display: none"
        :download="`EOD_${batchId}`"
        ref="downloadEODPDF"
        :href="EODPdfPath" />
      <iframe
      style="display: none;"
      ref="printPDF"
      id="printPDF"
      name="printPDF"
      width="100%"
      :src="pdfFilePath"
      height="600px" />
  </div>
  <Popup
    v-if="selectPrinterPopupOpened"
    minHeight="450px"
    :popupSmall=true
    :confirmText="$t('print')"
    @cancel="closePopup"
    @confirm="printEODDocument">
    <template v-slot:header>
      <h2>{{ $t('print') }}</h2>
    </template>
    <div>
      <div class="m-b-40">
        <InputSelect
          class="m-b-40"
          :label="$t('printer')"
          v-model="popupPrinterId"
          :options="get_document_printers"/>
      </div>
    </div>
  </Popup>
  <!-- HEADER -->
    <div class="row card info-wrap m-b-40" v-if="get_end_of_day !== null">
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            v-if="get_end_of_day.batch_agents_array.length > 1"
            :circle=true
            class="float-left m-r-15"
            name="fileCopies"
            size="24" />
          <LogosSVG
            v-if="get_end_of_day.batch_agents_array.length == 1"
            class="float-left m-r-15"
            :name="get_end_of_day.batch_agents_array[0]"
            size="40" />
          <div class="float-left">
            <p class="big-info-text">{{ get_end_of_day.batch_agents_array.join(', ') }}</p>
            <p class="small-info-text">{{ formatDate(get_end_of_day.batch_date) }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="savedItems"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ `${get_end_of_day.colli_amount} ${$t('colli').toLowerCase()}` }}</p>
            <p class="small-info-text">{{ `${get_end_of_day.shipment_count} ${$t('shipments').toLowerCase()}` }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="scale"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ get_end_of_day.batch_weight | weight }}</p>
            <p class="small-info-text">{{ `${get_end_of_day.batch_volume} dm` }}
              <span style="vertical-align: super;
                font-size: 10px;
                line-height: 0px;">3</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-xs-3">
        <div class="info-box c-float">
          <Icon
            :circle=true
            name="single"
            size="20"
            class="float-left m-r-15" />
          <div class="float-left">
            <p class="big-info-text">{{ get_end_of_day.sent_by_system_user || get_end_of_day.sent_user_name }}</p>
            <p class="small-info-text">{{ formatDate(get_end_of_day.batch_date, defaultDateTimeFormat()) }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- BODY -->
    <div class="row">
      <h2 class="m-b-20 section-title" v-if="get_end_of_day !== null">
        {{ $t('Shipments') }}
        <span class="grayed">{{ `(${get_end_of_day.shipment_count})` }}</span>
      </h2>
      <DataTable
        :dropdown=false
        :tableHeader=false
        :tableHead=false
        tableAPI="SINGLE_EOD_SHIPMENTS"
        tableActions="SINGLE_EOD_SHIPMENTS"
        :apiID="$route.params.id"
        :actionsOptions="actionsOptions"
        :totalCount="totalCount"
        :checkbox=true
        :type=type
        :count="get_end_of_day_shipments_count"
        :list="get_end_of_day_shipments"
        :referenceData="referenceData"
        :filterOptions="filterOptions"
        :rowActionParameter="rowActionParameter"
        @rowAction="rowAction"
        @actionOptionTriggered="actionOptionTriggered" />
    </div>
    <a
      style="display: none"
      :download="`EOD.csv`"
      ref="exportData"
      :href="exportDataPath" />
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import LogosSVG from "@/assets/images/logosSVG";
import DataTable from '@/components/table/index.vue';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import date from '@/mixins/date';

export default {
  name: 'EOD-View',
  components: {
    LogosSVG, DataTable, Btn, Dropdown, Popup, InputSelect,
  },
  mixins: [date],
  data() {
    return{
      selectPrinterPopupOpened: false,
      popupPrinterId: '',
      batchId: '',
      totalCount: 300,
      type: {
        type: true,
        data: 'goods_type',
        text: 'Type',
        icons: {
          1 : 'savedItems',
          2 : 'documentGoods',
          3 : 'pallet',
        },
      },
      rowActionParameter: {
        param: 'id',
        text: `${this.$t('View shipment')}`,
      },
      referenceData: [
        {
          shipping_product_name: `${this.$t('Shipping product name')}`,
          shipping_agent_name: `${this.$t('Shipping agent name')}`,
        },
        {
          trace_no: `${this.$t('track_number')}`,
          receiver_name: `${this.$t('receiver')}`,
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          receiver_reference: `${this.$t('Reciever ref.:')}`,
        },
      ],
      actionsOptions: [
        {
          text: `${this.$t('Remove shipment')}`,
          subText: `${this.$t('Remove from EOD')}`,
          icon: 'deleteForever',
        },
        {
          text: `${this.$t('Download list')}`,
          subText: `${this.$t('Download from EOD')}`,
          icon: 'cloudDownload',
        },
      ],
      dropdownOptions: [
        {
          text: `${this.$t('Download EOD')}`,
          subText: `${this.$t('Download EOD pdf')}`,
          icon: 'cloudDownload',
        },
        {
          text: `${this.$t('print')}`,
          subText: `${this.$t('Print EOD pdf')}`,
          icon: 'printer',
        },
      ],
      EODPdfPath: '',
      pdfFilePath: '',
      exportDataPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_end_of_day',
      'get_shipments_list',
      'get_shipments_count',
      'get_filters_menu',
      'get_active_filter',
      'get_end_of_day_shipments',
      'get_end_of_day_shipments_count',
      'get_user',
      'get_document_printers',
    ]),
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'allShipments',
        filterFields: [
          {
            label: this.$t('name'),
            type: 'input',
            model: 'name',
          },
          {
            label: this.$t('customer_no'),
            type: 'input',
            model: 'customer_number',
          }
        ],
      }
    },
  },
  created() {
    this.batchId = this.$route.params.id;
    this.$store.dispatch('GET_OPTIONS_FOR_SELECTS_PREFERENCES');
    this.$store.dispatch('GET_ONE_EOD', this.batchId);
  },
  methods: {
    rowAction(val) {
      this.$router.push(`/view-shipment/${val}`);
    },
    closePopup() {
      this.selectPrinterPopupOpened = false;
    },
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.downloadPDF();
      }
      if(opt === 'dropOption2') {
        this.printPDF();
      }
    },
    actionOptionTriggered(val) {
      if(val.dropOption == 'dropOption1'){
        this.$store.dispatch('REMOVE_SHIPMENT_EOD', {
          shipmentsIds: val.list,
          eodId: this.batchId,
        }).then(() => {
          this.$store.dispatch('GET_SINGLE_EOD_SHIPMENTS', {id: this.batchId});
        })
      }
      if(val.dropOption == 'dropOption2'){
        this.$store.dispatch('EXPORT_CSV', {
          tableName: 'end-of-day-shipments',
          ids: val.list,
        }).then((res) => {
          this.$nextTick(() => {
            const blob = new Blob([res], {type: "octet/stream"});
            const url = window.URL.createObjectURL(blob);
            this.$refs.exportData.href = url;
            // this.$refs.exportData.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(res);
            this.$refs.exportData.click();
            window.URL.revokeObjectURL(url);
          })
        });
      }
    },
    routeIt() {
      this.$router.go(-1);
    },
    downloadPDF() {
      this.$store.dispatch('DOWNLOAD_EOD', this.batchId).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadEODPDF.href = file;
          this.EODPdfPath = file;
          this.$refs.downloadEODPDF.click();
        })
      })
    },
    printPDF() {
      if (this.get_user.document_printer_id && parseInt(this.get_user.document_printer_id) > 0) {
        this.selectPrinterPopupOpened = true;
        this.popupPrinterId = this.get_user.document_printer_id;
      } else {
        this.$store.dispatch('PRINT_EOD', this.batchId).then((res) => {
          this.handlePrintResponse(res);
        })
      }
    },
    async handlePrintResponse(res) {
      const text = await (new Response(res)).text();
      try {
        const json = JSON.parse(text);
        if (json.data === 'browser_print') {
          this.$store.dispatch('DOWNLOAD_EOD', this.batchId).then((blob) => {
            this.triggerBrowserPrint(blob);
          });
          return;
        }
        if (json.data === 'direct_print') {
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: this.$t('print_job_sent_to_printer'),
            type: 'success-window',
          });
          return;
        }
      } catch (e) {
        // Not JSON, assume it's the PDF blob
        this.triggerBrowserPrint(res);
      }
    },
    triggerBrowserPrint(blob) {
      this.$nextTick(() => {
        const urlCreator = window.URL || window.webkitURL;
        let file = urlCreator.createObjectURL(blob);
        this.$refs.printPDF.src = file;
        this.$refs.printPDF.onload = () => {
          var self = this;
          setTimeout(() => {
            self.printPDFEOD();
          }, 1);
        };
      });
    },
    printEODDocument() {
      this.$store.dispatch('PRINT_EOD', { id: this.batchId, printer_id: this.popupPrinterId }).then((res) => {
        this.closePopup();
        this.handlePrintResponse(res);
      });
    },
    printPDFEOD() {
      this.$refs.printPDF.contentWindow.print();
    },
  },
  destroyed() {
    this.$store.dispatch('CLEAR_EOD_SINGLE');
  },
}
</script>
